/**
 * Aggregates .class file-related APIs under a single interface (Doppio.VM.ClassFile)
 */

import * as ConstantPool from './ConstantPool';
import * as Attributes from './attributes';

export * from './ClassData';
export * from './methods';
export * from './ClassLoader';
export * from './classpath';
export {ConstantPool, Attributes};



// WEBPACK FOOTER //
// ../../../src/ClassFile.ts